<template>
  <BittsModal
    variant="confirm"
    title="Remove filter"
    :description="description"
    primary-button-text="Remove filter"
    primary-button-type="danger"
    secondary-button-text="Cancel"
    :action-loading="isRemoving"
    @action="handleRemove"
    @closed="emit('closed')"
  />
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import { useFlashesStore, useIntegrationProfileStore } from '@/stores';

const { filterId, filterName } = defineProps<{
  filterId: string;
  filterName: string;
}>();

const emit = defineEmits<{
  removed: [];
  closed: [];
}>();

const integrationProfileStore = useIntegrationProfileStore();
const flashesStore = useFlashesStore();

const isRemoving = ref(false);

const description = computed(
  () =>
    `API calls that pass the ID for "${filterName}" will stop returning data. This action cannot be undone.`,
);

async function handleRemove() {
  isRemoving.value = true;
  try {
    const hasRemoved =
      await integrationProfileStore.deleteIntegrationProfile(filterId);
    if (!hasRemoved) {
      flashesStore.addErrorFlash({ message: 'Failed to remove filter' });
      return;
    }
    flashesStore.addSuccessFlash({ message: 'Filter removed' });
    emit('removed');
  } finally {
    isRemoving.value = false;
  }
}
</script>
